import React, { useState, useRef, useEffect } from 'react';
import {
    FormControl, FormControlLabel, Typography, TextField, RadioGroup, Radio, Checkbox,
    Button, Box, FormHelperText, Autocomplete
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSuppliersByCompanyId } from '../../../../redux/orderSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Country, State, City } from 'country-state-city';
import { updateCompanyAPI } from '../../../../redux/adminSlice';

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
export const ADD_EDIT_LOCATION_VALIDATION = yup.object().shape({
    country: yup.string().required('country cannot be empty.'),
    state: yup.string().required('state cannot be empty.'),
    city: yup.string().required('city cannot be empty.'),
    zip: yup.string()
        .matches(/^\d{5,}$/, 'Pincode must be at least 5 digits.')
        .test('non-eng-char', 'Pincode should not contain non-English characters.', value => !nonEngChar.test(value))
        .required('Pincode cannot be empty.'),
    address: yup.string() // not required in older one
        .max(300, 'Address cannot exceed 300 characters.')
        .test('non-eng-char', 'Address should not contain non-English characters.', value => !nonEngChar.test(value))
        .required('Address cannot be empty.'),

})
const AddEditLocation = ({onSubmit, handleStepChange, currentStep, actionType, className}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()


    const { loading } = useSelector((state) => state.order);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState([]);
    const [availableCountries, setAvailableCountries] = useState(countries);

    const { createdDate, modifiedDate, rejectedReason,rejectedDate,isActive, companyBuName, companyLogo,companyTypeName, parentCompanyName, user, ...rest } = location.state?.activeCompanyDetails || {};
    const initialValues =  location.state?.activeCompanyDetails || {};

    useEffect(() => {
        const fetchCountries = async () => {
            const countriesData = await Country.getAllCountries();
            const countriesWithDisabled = countriesData.map(country => ({
                value: country.isoCode,
                label: country.name,
                disabled: false
            }));
            setAvailableCountries(countriesWithDisabled);
            setCountries(countriesWithDisabled);
        };
        fetchCountries();
    }, []);

    useEffect(() => {
        const fetchStates = async () => {
            const statesData = await State.getAllStates();
            setStates(statesData.map(state => ({ value: state.name, label: state.name })));
        };
        if (location.state?.actionType === 'edit') {
            fetchStates();
        }
    }, []);

    useEffect(() => {
        const fetchCities = async () => {
            const citiesData = await City.getAllCities();
            setCities(citiesData.map(city => ({ value: city.name, label: city.name })));
        };
        if (location.state?.actionType === 'edit') {
            fetchCities();
        }
    }, []);
    const handleEditLocationChange = (values) => {
        const {...updatecompanyData} = values;
        console.log('handleEditLocationChange PPPP', updatecompanyData);
        const companyData = updatecompanyData;
    dispatch(updateCompanyAPI(companyData))
      .then((response) => {
        const companyDetails = response.payload

        if (companyDetails.result === true) {
          navigate(-1);
        } 
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
        // navigate(-1)
    }
    return (
        <>
         {actionType === "edit" && 
                <div className='ps-4 pe-4'><h1 className="fprimary">Location Details</h1></div>}
            <Formik
                initialValues={{
                    country: initialValues.country || '',
                    state: initialValues.state || '',
                    city: initialValues.city || '',
                    zip: initialValues.zip || '',
                    address: initialValues.address || '',
                    ...rest
                }}
                enableReinitialize={true}
                validationSchema={ADD_EDIT_LOCATION_VALIDATION}
                onSubmit={(values, { setSubmitting }) => {
                    if (location.state?.actionType === 'edit') {
                        handleEditLocationChange({...values})                      
                    }
                    onSubmit(values);
                    setSubmitting(false);
                }}
            >
                {formikProps => {
                    const {
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                    } = formikProps;

                    const handleCountryChange = (_, newValue) => {
                        setSelectedCountry(newValue);
                        setFieldValue('country', newValue ? newValue.label : '');
                        if (newValue) {
                            const countryStates = State.getStatesOfCountry(newValue.value);
                            setStates(countryStates.map(state => ({ label: state.name, value: state.isoCode })));
                        } else {
                            setStates([]);
                            setCities([]);
                        }
                        setSelectedState(null); // Reset selected state when country changes
                        setSelectedCity(null); // Reset selected city when country changes
                        setFieldValue('state', null);
                        setFieldValue('city', null);
                    };

                    const handleStateChange = (_, newValue) => {
                        setSelectedState(newValue);
                        setFieldValue('state', newValue ? newValue.label : '');
                        if (newValue) {
                            const stateCities = City.getCitiesOfState(selectedCountry?.value, newValue.value);
                            setCities(stateCities.map(city => ({ label: city.name, value: city.name })));
                        } else {
                            setCities([]);
                        }
                        setSelectedCity(null); // Reset selected city when state changes
                    };

                    const handleCityChange = (_, newValue) => {
                        setSelectedCity(newValue);
                        setFieldValue('city', newValue ? newValue.label : '');
                    };

                    return (
                            <div className="card-body m-2">
                                <Form onSubmit={handleSubmit}>
                                    <div className="row m-2">
                                        <div className="col-md-3 cs-form mb-3">
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="country-select"
                                                    options={countries}
                                                    getOptionLabel={(option) => option.label}
                                                    value={countries.find(country => country.label === values.country) || null}
                                                    onChange={handleCountryChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Country" variant="outlined" error={touched.country && Boolean(errors.country)} helperText={touched.country && errors.country} />
                                                    )}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-3 cs-form mb-3">
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="state-select"
                                                    options={states}
                                                    getOptionLabel={(option) => option.label}
                                                    value={states.find(state => state.label === values.state) || null}
                                                    onChange={handleStateChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="State" variant="outlined" error={touched.state && Boolean(errors.state)} helperText={touched.state && errors.state} />
                                                    )}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-3 cs-form mb-3">
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="city-select"
                                                    options={cities}
                                                    getOptionLabel={(option) => option.label}
                                                    value={cities.find(city => city.label === values.city) || null}
                                                    onChange={handleCityChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="City" variant="outlined" error={touched.city && Boolean(errors.city)} helperText={touched.city && errors.city} />
                                                    )}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-3 cs-form mb-3">
                                            <TextField
                                                fullWidth
                                                label="Pincode"
                                                name="zip"
                                                value={values.zip}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.zip && Boolean(errors.zip)}
                                                helperText={touched.zip && errors.zip}
                                            />
                                        </div>
                                        <div className="cs-form mb-3">
                                            <TextField
                                                fullWidth
                                                label="Address"
                                                name="address"
                                                value={values.address}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.address && Boolean(errors.address)}
                                                helperText={touched.address && errors.address}
                                                multiline
                                                rows={4}
                                                margin="normal"
                                            />
                                        </div>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                                            <button type="button" className="btn btn-light grey-btn lg-btn"
                                               onClick={location.state?.actionType !== 'edit'? (() => handleStepChange(currentStep - 1)) : (() => navigate(-1))}>
                                                Back
                                            </button>
                                            <button type="submit" className="btn btn-primary greeen-btn lg-btn lg-btn"
                                                variant="contained"
                                                // disabled={loading}
                                                >
                                                {/* {loading ? 'Submitting...' : 'Submit'} */}
                                                {location.state?.actionType !== 'edit' ? "Next" : "Submit"}
                                            </button>
                                        </Box>
                                    </div>
                                </Form>
                            </div>
                    );
                }}
            </Formik>
        </>
    )
}

export default AddEditLocation